export enum TextColor {
  success = 'text-success',
  info = 'text-info',
  muted = 'text-muted',
  dark = 'text-dark',
  danger = 'text-danger',
  gray500 = 'text-gray-500'
}
